import { Env } from '@sanlam-glacier/app-common/types/env/Env.type.js';

export const getCurrentAuthMethod = (env: Env) => {
  return {
    isUsingAfSso: env.auth.method === 'afSso',
    isUsingClient: env.auth.method === 'client'
  };
};
